import styled from "styled-components";
import "./SignOutPage.css";
import { connect } from "react-redux";
import { signOutAPI } from "../actions";
import { Link } from "react-router-dom";

function SignOutPage(props) {
  return (
    <div className="signout">
      <div className="dev__header">
        <a href="/home">
          <img
            className="dev__img"
            src="images/login-logo.svg"
            alt="Go to Home"
          />
        </a>
        <button>About Developer</button>
      </div>
      <img className="hero" src="images/signout.png" alt="signout" />
      <p>
        <q>If opportunity does not knock, build a door</q>
      </p>
      <SignOut onClick={() => props.signOut()}>
        <Link className="linkto" to="/">
          <button>Signout</button>
        </Link>
      </SignOut>
    </div>
  );
}
const SignOut = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  width: auto;
  border-radius: 28px;
  z-index: 0;
  transition-duration: 167ms;
  background-color: #2977c9;
  &:hover {
    background-color: rgba(207, 207, 207, 0.25);
    color: rgba(0, 0, 0, 0.75);
    border: 1px solid #2977c9;
  }
  button {
    background-color: #2977c9;
    color: white;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 20px;
    border: none;
    width: 100%;
    border-radius: 28px;
    height: 100%;
    align-items: center;
  }
  button:hover {
    background-color: rgba(207, 207, 207, 0.25);
    color: #2977c9;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 20px;
    border-color: #2977c9;
    align-items: center;
    font-weight: 600;
  }
`;
const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  signOut: () => dispatch(signOutAPI()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignOutPage);
